import React from "react";

import { ButtonBase, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

interface Props {
  name: string;
  active?: boolean;
  onClick?: () => void;
}

const useStyles = makeStyles()({
  active: {
    backgroundColor: colors.primary,
    color: colors.white,
    "&:hover": {
      backgroundColor: "#12c4a0",
    },
  },
});

const StyledButtonBase = withStyles(ButtonBase, {
  root: {
    backgroundColor: "white",
    height: "60px",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    marginBottom: "12px",
    padding: "8px",
    width: "100%",
  },
});

const ExerciseNameText = withStyles(Typography, {
  root: {
    fontSize: 14,
    fontWeight: 700,
  },
});

const ExerciseTab: React.FC<Props> = ({ name, active, onClick }) => {
  const { classes } = useStyles();

  return (
    <StyledButtonBase
      className={`${active && classes.active}`}
      onClick={onClick}
    >
      <ExerciseNameText>{name}</ExerciseNameText>
    </StyledButtonBase>
  );
};

export default ExerciseTab;
